export const MARKETING_STUDIO_CANVAS_PATTERN = /\/marketing\/\d+\/studio\/[a-f0-9-]{36}/;
const useIsMarketingStudioCanvas = () => {
  return MARKETING_STUDIO_CANVAS_PATTERN.test(window.location.pathname);
};
export default useIsMarketingStudioCanvas;